import TechAddToPortfolioSuccess from './TechAddToPortfolioSuccess';

export default TechAddToPortfolioSuccess;
